module.exports = __webpack_public_path__ + "static/img/2_1_3_2.8d8f4600.jpg";